import styled, { css } from 'styled-components';

export const Container = styled.div`
    display: flex;
    gap: 0.5rem;
    color: #999;
    font-size: 11px; 
    justify-content: end;
    flex-direction: row;
    margin: -15px 0px 0px 0px;
    user-select: none;

    ${({ isUserSystem }) =>
        isUserSystem &&
        css`
           margin: 0px;
           margin: 0px;
        `
    } 
    .msg--nameAuthor{
        display: flex;
        width: 100%;
    }
    .msg--status{
        display: flex;
        gap: 0.3rem;
    }
`;